import { ORGANIZATION_SEARCH_QUERY, ORGANIZATION_SEARCH_RECEIVE, ORGANIZATION_SEARCH_SHOW_FULL_FORM, ORGANIZATION_SEARCH_SELECT_ITEM, ORGANIZATION_TOGGLE_RESULT } from '../constants';
const DEFAULT_STATE = {
    query: '',
    result: [],
    showResult: false,
    selectedItem: -1
};
export const organizationSearch = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ORGANIZATION_SEARCH_QUERY:
        case ORGANIZATION_SEARCH_RECEIVE:
        case ORGANIZATION_SEARCH_SHOW_FULL_FORM:
        case ORGANIZATION_SEARCH_SELECT_ITEM:
        case ORGANIZATION_TOGGLE_RESULT:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
